import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '二十大时光';
const baseUrl = '20221015SG';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/news`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsTwo',
      name: `${baseUrl}-newsTwo`,
      component: () => import('./pages/NewsTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsThree',
      name: `${baseUrl}-newsThree`,
      component: () => import('./pages/NewsThree.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
